(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6340],{

/***/ 66323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90171);
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 270 47",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M76.306 18.209c-.001-2.691-2.318-4.822-5.028-4.822h-6.052a.484.484 0 0 0-.486.483v8.939c0 .266.217.483.486.483h5.06c3.269 0 6.022-1.666 6.02-5.083m-2.317 9.625c-.232.051-.35.314-.219.51a10.31 10.31 0 0 0 8.09 4.564.338.338 0 0 1 .328.335v4.856c0 .19-.16.347-.351.34a15.884 15.884 0 0 1-14.274-10.023.338.338 0 0 0-.314-.215h-2.023a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.487-.483h10.993c6.063 0 11.61 3.202 11.61 9.734 0 5.42-3.601 8.634-8.208 9.665m164.66-4.393c0-5.597-4.586-10.15-10.223-10.15-5.638 0-10.224 4.553-10.224 10.15s4.586 10.15 10.224 10.15c5.637 0 10.223-4.553 10.223-10.15m5.528 0c0 8.623-7.066 15.639-15.751 15.639-8.686 0-15.752-7.016-15.752-15.64 0-8.622 7.066-15.638 15.752-15.638 8.685 0 15.75 7.016 15.75 15.639m-137.19-5.232c-.001-2.691-2.318-4.822-5.028-4.822h-6.053a.484.484 0 0 0-.486.483v8.939c0 .266.218.483.486.483h5.061c3.269 0 6.021-1.666 6.02-5.083m5.89-.04c0 6.702-5.503 10.032-11.609 10.032h-5.362a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.486.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.486-.483h10.994c6.063 0 11.61 3.202 11.61 9.734m156.64-9.734h-22.321a.482.482 0 0 0-.484.48v4.163c0 .265.216.48.484.48h7.882c.267 0 .484.215.484.48v23.929c0 .265.216.48.484.48h4.62a.482.482 0 0 0 .485-.48V14.038c0-.265.216-.48.484-.48h7.881a.482.482 0 0 0 .484-.48V8.915a.482.482 0 0 0-.483-.48m-67.512 14.9c0-6.447-4.687-9.606-10.491-9.606h-4.805a.482.482 0 0 0-.484.48v18.464c0 .265.216.48.484.48h4.805c5.804 0 10.491-3.202 10.491-9.819m5.89 0c0 10.118-7.74 15.113-16.21 15.113h-10.609a.482.482 0 0 1-.484-.48V8.915c0-.265.217-.48.484-.48h10.61c8.47 0 16.21 4.952 16.21 14.9m-46.19 9.989h-12.62a.482.482 0 0 1-.484-.48V26.12c0-.265.217-.48.483-.48h11.373a.483.483 0 0 0 .484-.48v-3.907a.482.482 0 0 0-.484-.48h-11.372a.482.482 0 0 1-.484-.48v-6.255c0-.265.217-.48.483-.48h12.406a.482.482 0 0 0 .483-.48V8.915a.482.482 0 0 0-.483-.48h-18.038a.482.482 0 0 0-.484.48v29.052c0 .265.217.48.484.48h18.252a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.483-.48m-24.9 0h-11.803a.482.482 0 0 1-.483-.48V8.915a.482.482 0 0 0-.484-.48h-4.665a.483.483 0 0 0-.484.48v29.052c0 .265.217.48.484.48h17.435a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.484-.48M16.94 18.209c-.002-2.691-2.318-4.822-5.029-4.822H5.86a.485.485 0 0 0-.486.483v8.939c0 .266.218.483.486.483h5.06c3.27 0 6.023-1.666 6.02-5.083m5.891-.04c0 6.702-5.504 10.032-11.609 10.032H5.859a.485.485 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483H.227a.485.485 0 0 1-.486-.483V8.918c0-.267.217-.483.486-.483h10.994c6.062 0 11.61 3.202 11.61 9.734m28.755-9.252V28.287c0 6.446-5.073 10.715-11.566 10.715-6.45 0-11.48-4.27-11.48-10.715V8.917c0-.266.217-.482.485-.482h4.663c.267 0 .485.216.485.482v19.199c0 3.287 2.236 5.592 5.675 5.592 3.783 0 6.106-2.39 6.106-5.592V8.917c0-.266.217-.482.484-.482h4.664c.267 0 .484.216.484.482",
    fill: "#8F17D1"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M73.99 27.834c-.233.051-.351.314-.22.51a10.31 10.31 0 0 0 8.09 4.564.338.338 0 0 1 .328.335v4.856c0 .19-.16.347-.351.34a15.884 15.884 0 0 1-14.274-10.023.338.338 0 0 0-.314-.215h-2.023a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.487-.483h10.993c6.063 0 11.61 3.202 11.61 9.734 0 5.42-3.601 8.634-8.208 9.665M244.177 23.44c0 8.624-7.066 15.64-15.751 15.64-8.686 0-15.752-7.016-15.752-15.64 0-8.622 7.066-15.638 15.752-15.638 8.685 0 15.75 7.016 15.75 15.639M112.877 18.169c0 6.702-5.504 10.032-11.61 10.032h-5.362a.484.484 0 0 0-.486.482v9.281a.485.485 0 0 1-.486.483h-4.66a.485.485 0 0 1-.486-.483V8.918c0-.267.218-.483.486-.483h10.994c6.063 0 11.61 3.202 11.61 9.734M269.517 8.435h-22.321a.482.482 0 0 0-.484.48v4.163c0 .265.216.48.484.48h7.882c.267 0 .484.215.484.48v23.929c0 .265.216.48.484.48h4.62a.482.482 0 0 0 .485-.48V14.038c0-.265.216-.48.484-.48h7.881a.482.482 0 0 0 .484-.48V8.915a.482.482 0 0 0-.483-.48M207.896 23.334c0 10.118-7.74 15.113-16.21 15.113h-10.61a.482.482 0 0 1-.484-.48V8.915c0-.265.217-.48.484-.48h10.61c8.47 0 16.21 4.952 16.21 14.9M161.706 33.324h-12.62a.482.482 0 0 1-.484-.48V26.12c0-.265.217-.48.483-.48h11.373a.483.483 0 0 0 .484-.48v-3.907a.482.482 0 0 0-.484-.48h-11.372a.482.482 0 0 1-.484-.48v-6.255c0-.265.217-.48.483-.48h12.406a.482.482 0 0 0 .483-.48V8.915a.482.482 0 0 0-.483-.48h-18.038a.482.482 0 0 0-.484.48v29.052c0 .265.217.48.484.48h18.252a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.483-.48M136.806 33.324h-11.803a.482.482 0 0 1-.483-.48V8.915a.482.482 0 0 0-.484-.48h-4.665a.483.483 0 0 0-.484.48v29.052c0 .265.217.48.484.48h17.435a.482.482 0 0 0 .484-.48v-4.163a.482.482 0 0 0-.484-.48M22.83 18.169c0 6.702-5.504 10.032-11.609 10.032H5.859a.485.485 0 0 0-.486.482v9.281a.485.485 0 0 1-.487.483H.227a.485.485 0 0 1-.486-.483V8.918c0-.267.217-.483.486-.483h10.994c6.062 0 11.61 3.202 11.61 9.734M51.586 8.917V28.287c0 6.446-5.073 10.715-11.566 10.715-6.45 0-11.48-4.27-11.48-10.715V8.917c0-.266.217-.482.485-.482h4.663c.267 0 .485.216.485.482v19.199c0 3.287 2.236 5.592 5.675 5.592 3.783 0 6.106-2.39 6.106-5.592V8.917c0-.266.217-.482.484-.482h4.664c.267 0 .484.216.484.482"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgLogo);

/***/ }),

/***/ 89774:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopper",
      function () {
        return __webpack_require__(20445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
var safeGetLocalStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
};
var setListener = function(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
};
var setItem = function(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
};
var getItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string ? JSON.parse(string) : string;
};
var removeItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 37175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.ts
var local_storage = __webpack_require__(93960);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js

function broadcastMessageToTabs(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
}

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.js

function safeGetSessionStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
}
function isAvailable() {
    return !!safeGetSessionStorage();
}
function getItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
}
function setItem(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
}
function removeItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 91280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L6": function() { return /* reexport */ connectToPlacementParent; }
});

// UNUSED EXPORTS: getAllPlacementContainers, getPlacementContainer, getPlacementContainers, getPlacementIframe, getPlacementIframes, injectPlacementIframe

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(22130);
// EXTERNAL MODULE: ../../../../../node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(69502);
// EXTERNAL MODULE: ../../../../libraries/src/iframe-connect/index.js + 3 modules
var iframe_connect = __webpack_require__(64331);
;// CONCATENATED MODULE: ../../../../placement-iframe/placement-manager.ts





function injectPlacementIframe(param) {
    var hostURL = param.hostURL, src = param.src, style = param.style, dataRequestHandlers = param.dataRequestHandlers, placementType = param.placementType, instanceId = param.instanceId, _listenForResize = param.listenForResize, listenForResize = _listenForResize === void 0 ? true : _listenForResize, _allowMultiple = param.allowMultiple, allowMultiple = _allowMultiple === void 0 ? false : _allowMultiple;
    if (getPlacementIframe({
        instanceId: instanceId,
        placementType: placementType
    }) && !allowMultiple) {
        // biome-ignore lint/nursery/noConsole: log
        console.warn("PurpleDot.load(): Placement already configured, use update() to update it.");
        return Promise.resolve();
    }
    var containerElement = getPlacementContainer({
        instanceId: instanceId,
        placementType: placementType
    });
    if (!_instanceof(containerElement, HTMLElement)) {
        return Promise.resolve();
    }
    var autoInstanceId = 1;
    if (!instanceId) {
        containerElement.dataset.purpleDotInstanceId = "".concat(autoInstanceId);
    }
    var iframe = createPlacementIframe(src, style, {
        placementType: placementType,
        instanceId: "".concat(instanceId || autoInstanceId)
    });
    updateIframeURL(iframe, src);
    containerElement.appendChild(iframe);
    return connectToIframe({
        hostURL: hostURL,
        iframe: iframe,
        dataRequestHandlers: dataRequestHandlers
    }).then(function(child) {
        var container = getPlacementContainer({
            instanceId: instanceId,
            placementType: placementType
        });
        if (!_instanceof(container, HTMLElement)) {
            return;
        }
        showIfHidden(container);
        if (listenForResize) {
            child.on("window-size-changed", function(param) {
                var width = param.width, height = param.height;
                if (height) {
                    iframe.style.height = "".concat(height, "px");
                }
                // Only apply width changes to inline-block iframes
                if (width && iframe.style.display === "inline-block") {
                    iframe.style.width = "".concat(width, "px");
                }
            });
        }
        return {
            childBridge: child,
            iframe: iframe
        };
    }).catch(function(err) {
        // biome-ignore lint/nursery/noConsole: log
        console.error(err);
        var container = getPlacementContainer({
            instanceId: instanceId,
            placementType: placementType
        });
        if (!_instanceof(container, HTMLElement)) {
            return;
        }
        hide(container);
        var _data = err.data, reason = _data.reason, message = _data.message;
        // biome-ignore lint/nursery/noConsole: log
        console.info("Purple Dot placement '".concat(placementType, "' not shown, reason: '").concat(reason, ": ").concat(message, "'"));
        throw err;
    });
}
function connectToPlacementParent() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return iframe_connect/* connectToParentPage.apply */.V$.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(parentBridge) {
        var elem = document.body;
        var resizeObserver = new resize_observer/* ResizeObserver */["do"](function() {
            parentBridge.emit("window-size-changed", {
                width: elem.offsetWidth,
                height: elem.offsetHeight
            });
        });
        resizeObserver.observe(elem);
        return parentBridge;
    });
}
function createPlacementIframe(src, style, param) {
    var placementType = param.placementType, instanceId = param.instanceId;
    /* eslint-disable no-param-reassign */ var iframe = document.createElement("iframe");
    iframe.dataset.placementType = placementType;
    iframe.dataset.instanceId = instanceId;
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("class", "purple-dot-frame");
    iframe.style.border = "none";
    iframe.style.width = (style === null || style === void 0 ? void 0 : style.width) || "100%";
    iframe.style.height = style && (style.initialHeight || style.height) || "54px";
    iframe.style.display = (style === null || style === void 0 ? void 0 : style.display) || "block";
    updateIframeURL(iframe, src);
    return iframe;
/* eslint-enable no-param-reassign */ }
function updateIframeURL(ifrm, url) {
    ifrm.dataset.loaded = "false"; // eslint-disable-line no-param-reassign
    ifrm.addEventListener("load", function() {
        // Used by Cypress when running tests to check if iframe already loaded
        ifrm.dataset.loaded = "true"; // eslint-disable-line no-param-reassign
    });
    setIframeSrc(ifrm, url);
}
function setIframeSrc(ifrm, url) {
    ifrm.setAttribute("src", url);
}
function showIfHidden(el) {
    if ((el === null || el === void 0 ? void 0 : el.style.display) === "none" && el.dataset.originalDisplay) {
        // eslint-disable-next-line no-param-reassign
        el.style.display = el.dataset.originalDisplay;
    }
}
function hide(el) {
    if (!el.dataset.originalDisplay) {
        // eslint-disable-next-line no-param-reassign
        el.dataset.originalDisplay = window.getComputedStyle(el).display;
    }
    // eslint-disable-next-line no-param-reassign
    el.style.display = "none";
}

;// CONCATENATED MODULE: ../../../../placement-iframe/index.ts




/***/ }),

/***/ 85391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81142);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62204);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93960);
/* harmony import */ var _components_common_segment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5721);




function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
}
function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
}
var FilterWrapper = {
    identify: function identify(userId, traits, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.identify */ .W.identify(userId, traits, options, callback);
        } else {
            // biome-ignore lint/nursery/noConsole: debug
            console.log("INTERNAL USER - Identify: ", userId);
        }
    },
    track: function track(event, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.track */ .W.track(event, properties, options, callback);
        } else {
            // biome-ignore lint/nursery/noConsole: debug
            console.log("INTERNAL USER - Track: ", event, properties, options, callback);
        }
    },
    page: function page(category, name, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.page */ .W.page(category, name, properties, options, callback);
        } else {
            // biome-ignore lint/nursery/noConsole: debug
            console.log("INTERNAL USER - Page: ", category, name, properties, options, callback);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackTagScanned: function trackTagScanned(param) {
        var itemId = param.itemId, scannedCode = param.scannedCode, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackTagScanned()");
        }
        if (!scannedCode) {
            throw new Error("No scannedCode provided to Analytics.trackTagScanned()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackTagScanned()");
        }
        FilterWrapper.track("Tag Scanned", {
            itemId: itemId,
            scannedCode: scannedCode,
            shopCode: shopCode
        });
    },
    trackCodeEntered: function trackCodeEntered(param) {
        var enteredCode = param.enteredCode, codeType = param.codeType;
        if (!enteredCode) {
            throw new Error("No enteredCode provided to Analytics.trackCodeEntered()");
        }
        if (!codeType) {
            throw new Error("No codeType provided to Analytics.trackCodeEntered()");
        }
        if (codeType === "tag") {
            FilterWrapper.track("Tag Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "item") {
            FilterWrapper.track("Shareable Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "external") {
            FilterWrapper.track("External Shop Code Entered", {
                enteredCode: enteredCode
            });
        }
    },
    trackInstagramLinkFollowed: function trackInstagramLinkFollowed(param) {
        var itemId = param.itemId, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackInstagramLinkFollowed()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackInstagramLinkFollowed()");
        }
        FilterWrapper.track("Instagram Link Followed", {
            itemId: itemId,
            shopCode: shopCode
        });
    },
    trackImageGalleryInteraction: function trackImageGalleryInteraction(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackImageViewed()");
        }
        FilterWrapper.track("Interacted with Image Gallery", {
            itemId: itemId
        });
    },
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackCheckoutStarted: function trackCheckoutStarted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackCheckoutStarted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackCheckoutStarted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackCheckoutStarted()");
        }
        FilterWrapper.track("Checkout Started", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderSubmitted: function trackOrderSubmitted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackOrderSubmitted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackOrderSubmitted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackOrderSubmitted()");
        }
        FilterWrapper.track("Order Submitted", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackOrderFailed: function trackOrderFailed() {
        FilterWrapper.track("Order Failed");
    },
    trackShippingMethodSelected: function trackShippingMethodSelected(param) {
        var shippingOption = param.shippingOption;
        if (!shippingOption) {
            throw new Error("No shippingOption provided to Analytics.trackShippingMethodSelected()");
        }
        FilterWrapper.track("Shipping Method Selected", {
            shippingOption: shippingOption
        });
    },
    trackPaymentMethodSelected: function trackPaymentMethodSelected(param) {
        var paymentMethod = param.paymentMethod;
        if (!paymentMethod) {
            throw new Error("No paymentMethod provided to Analytics.trackPaymentMethodSelected()");
        }
        FilterWrapper.track("Payment Method Selected", {
            paymentMethod: paymentMethod
        });
    },
    trackLearnMoreClicked: function trackLearnMoreClicked() {
        FilterWrapper.track("Learn More Clicked");
    },
    trackLearnMoreModalDismissed: function trackLearnMoreModalDismissed() {
        FilterWrapper.track("Learn More Modal Dismissed");
    },
    trackSizeChanged: function trackSizeChanged(param) {
        var itemId = param.itemId, selectedItemId = param.selectedItemId, slug = param.slug;
        FilterWrapper.track("Size Changed", {
            itemId: itemId,
            selectedItemId: selectedItemId,
            slug: slug
        });
    },
    trackMerchantItemUrlVisit: function trackMerchantItemUrlVisit(param) {
        var source = param.source, itemMerchantUrl = param.itemMerchantUrl;
        FilterWrapper.track("Item Merchant Link Visited", {
            source: source,
            itemMerchantUrl: itemMerchantUrl
        });
    },
    trackTrendingItemSelected: function trackTrendingItemSelected(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Trending Item Selected", {
            itemId: itemId,
            slug: slug
        });
    },
    trackTrendingScrolled: function trackTrendingScrolled() {
        FilterWrapper.track("Trending Scrolled");
    },
    trackRetailerModalOpened: function trackRetailerModalOpened() {
        FilterWrapper.track("Retailer Modal Opened");
    },
    trackShareModalOpened: function trackShareModalOpened(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Share Modal Opened", {
            itemId: itemId,
            slug: slug
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackSectionExpanded: function trackSectionExpanded(param) {
        var title = param.title;
        if (!title) {
            throw new Error("No title provided to Analytics.trackSectionExpanded");
        }
        FilterWrapper.track("".concat(title, " Expanded"));
    },
    trackShareLinkFollowed: function trackShareLinkFollowed(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No title provided to Analytics.trackShareLinkFollowed");
        }
        FilterWrapper.track("Unique Product Share Link Followed", {
            itemId: itemId
        });
    },
    trackNewsletterSignup: function trackNewsletterSignup() {
        FilterWrapper.track("Newsletter Sign Up");
    },
    trackSuggestClicked: function trackSuggestClicked() {
        FilterWrapper.track("Suggest an Item Clicked");
    },
    trackSuggestionSubmitted: function trackSuggestionSubmitted() {
        FilterWrapper.track("Suggestion Submitted");
    },
    trackExplainerVideoPlayed: function trackExplainerVideoPlayed() {
        FilterWrapper.track("Explainer Video Played");
    },
    trackExplainerVideoPaused: function trackExplainerVideoPaused(param) {
        var timeViewed = param.timeViewed;
        FilterWrapper.track("Explainer Video Paused", {
            timeViewed: timeViewed
        });
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    },
    trackUserEngagedWithLandingPage: function trackUserEngagedWithLandingPage(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserEngagedWithLandingPage");
        }
        FilterWrapper.track("Engaged With Landing Page", {
            pageName: pageName
        });
    },
    trackSizeGuideClicked: function trackSizeGuideClicked() {
        FilterWrapper.track("Size Guide Clicked");
    },
    trackVisitDemoStoreClicked: function trackVisitDemoStoreClicked() {
        FilterWrapper.track("Visit Demo Store Clicked");
    },
    trackGetInTouchClicked: function trackGetInTouchClicked() {
        FilterWrapper.track("Get In Touch Clicked");
    },
    trackMerchantContactFormSubmitted: function trackMerchantContactFormSubmitted() {
        FilterWrapper.track("Merchant Contact Form Submitted");
    },
    trackStoreSignupReview: function trackStoreSignupReview() {
        FilterWrapper.track("Store Review Form Submitted");
    },
    trackSurveyCTAClick: function trackSurveyCTAClick() {
        FilterWrapper.track("Survey CTA Clicked");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 73409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78839);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37175);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var _client_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85391);
/* harmony import */ var _head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44587);
/* harmony import */ var _page_level_progress_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55187);








var defaultDescription = "Purple Dot lets you sell sooner to shoppers who are willing to wait. Bring products to market faster, test demand or avoid deep discounts.";
function Page(param) {
    var pageName = param.pageName, title = param.title, _titleSuffix = param.titleSuffix, titleSuffix = _titleSuffix === void 0 ? "Purple Dot" : _titleSuffix, noIndex = param.noIndex, description = param.description, head = param.head, children = param.children;
    useTrackingData(pageName);
    var titleText = "".concat(title).concat(titleSuffix ? " | " : "").concat(titleSuffix);
    var descriptionText = description || defaultDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_page_level_progress_bar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_head__WEBPACK_IMPORTED_MODULE_4__/* .Head */ .F, {
                title: titleText,
                description: descriptionText,
                noIndex: noIndex,
                children: head
            }),
            (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children, Function) ? children({
                title: titleText,
                description: descriptionText
            }) : children
        ]
    });
}
function useTrackingData(pageName) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        trackPageView(pageName);
    }, [
        pageName,
        router.asPath
    ]);
    // Track when the user navigates away from their first page so we can set up exit rate
    // as a metric in our analytics and ad tools
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        function trackUserProgressed() {
            if (!(0,_purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__/* .getItem */ .rV)("userProgressed")) {
                _client_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].trackUserProgressed */ .Z.trackUserProgressed(pageName);
            }
            (0,_purple_dot_browser_sdk_src_libraries_session_storage__WEBPACK_IMPORTED_MODULE_7__/* .setItem */ .LS)("userProgressed", true, {
                broadcast: false
            });
            router.events.off("routeChangeComplete", trackUserProgressed);
        }
        router.events.on("routeChangeComplete", trackUserProgressed);
    }, [
        pageName,
        router.events
    ]);
}
function trackPageView(pageName) {
    // By the time Track Page is called title
    // isnt set, setTimout allows the title to be updated
    // https://github.com/zeit/next.js/issues/6025
    setTimeout(function() {
        _client_analytics__WEBPACK_IMPORTED_MODULE_3__/* ["default"].page */ .Z.page(pageName);
    }, 0);
}
/* harmony default export */ __webpack_exports__["Z"] = (Page);


/***/ }),

/***/ 44587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94843);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var _config_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43985);
/* harmony import */ var _segment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5721);





function Head(param) {
    var title = param.title, description = param.description, noIndex = param.noIndex, children = param.children;
    var segmentApiKey = (0,_config_context__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .Z)().segmentApiKey;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "UTF-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== null && title !== void 0 ? title : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description !== null && description !== void 0 ? description : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                sizes: "180x180",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/static/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "mask-icon",
                href: "/static/favicon-mask.svg",
                color: "#5bbad5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: "/static/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "/static/favicon-32x32.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/static/favicon-16x16.png"
            }),
            segmentApiKey && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_segment__WEBPACK_IMPORTED_MODULE_4__/* .SegmentSnippet */ .u, {
                apiKey: segmentApiKey
            }),
            noIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            children
        ]
    });
}


/***/ }),

/***/ 55187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5567);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31898);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35823);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2647);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31683);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);







var PageLevelProgressBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(PageLevelProgressBar, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PageLevelProgressBar);
    function PageLevelProgressBar() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, PageLevelProgressBar);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(PageLevelProgressBar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeStart", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().start();
                });
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeComplete", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                });
                next_router__WEBPACK_IMPORTED_MODULE_0__.Router.events.on("routeChangeError", function() {
                    return nprogress__WEBPACK_IMPORTED_MODULE_1___default().done();
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children;
            }
        }
    ]);
    return PageLevelProgressBar;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (PageLevelProgressBar);


/***/ }),

/***/ 97323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60586);
/* harmony import */ var _typeform_embed_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40287);
/* harmony import */ var _typeform_embed_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94843);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11141);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90171);
/* harmony import */ var _common_base_page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73409);
/* harmony import */ var _common_config_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43985);
/* eslint react/no-unescaped-entities: "off" */ 






function ShopperFAQ() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typeform_embed_react__WEBPACK_IMPORTED_MODULE_1__.Sidetab, {
        id: "avSmu8nj",
        buttonText: "Get help"
    });
}
function ShopperPage(param) {
    var pageName = param.pageName, _title = param.title, title = _title === void 0 ? "Find your pre-order" : _title, titleSuffix = param.titleSuffix, noIndex = param.noIndex, _description = param.description, description = _description === void 0 ? "Find your pre-order, update your shipping address or cancel your pre-order" : _description, embedded = param.embedded, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_base_page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        pageName: pageName,
        title: title,
        titleSuffix: titleSuffix,
        description: description,
        noIndex: noIndex,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VisitorHead, {}),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HideForEmbedded, {
                embedded: embedded,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopperFAQ, {})
            })
        ]
    });
}
function HideForEmbedded(param) {
    var children = param.children, embedded = param.embedded;
    return embedded ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
}
function VisitorHead() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var host = (0,_common_config_context__WEBPACK_IMPORTED_MODULE_6__/* .useConfig */ .Z)().host;
    var canonical = host ? "".concat(host).concat(router.asPath.split("?")[0]) : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://purple-dot.imgix.net"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://config.gorgias.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://www.googletagmanager.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://www.googleadservices.com"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: 300;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: 400;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff2') format('woff2'),\n              url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: normal;\n            font-style: italic;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-RegularItalic.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-RegularItalic.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: bold;\n            font-style: normal;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka';\n            font-weight: bold;\n            font-style: italic;\n            font-display: auto;\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-BoldItalic.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-BoldItalic.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka-Book';\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Book.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka-Regular';\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Regular.woff') format('woff');\n          }\n\n          @font-face {\n            font-family: 'Jungka-Bold';\n            src: url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff2') format('woff2'),\n                url('https://www.purpledotprice.com/static/webfonts/Jungka-Bold.woff') format('woff');\n          }\n        "
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ShopperPage);


/***/ }),

/***/ 40815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38137);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24686);
/* harmony import */ var _common_ThemedButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57565);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 36px;\n\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  \n  &:hover {\n    text-decoration: none;\n    box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.3),\n      0 10px 10px -5px rgba(143, 23, 209, 0.4);\n  }\n  \n  :disabled:hover {\n    box-shadow: none;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var ShopperThemedButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_common_ThemedButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_templateObject(), function(param) {
    var embedded = param.embedded;
    return !embedded && "\n      text-transform: none;\n\n      border-radius: 29px;\n      border: 2px solid ".concat(function(param) {
        var theme = param.theme;
        return theme.button.enabled.backgroundColor;
    }, ";\n\n      font-size: 14px;\n\n      line-height: 14px;\n      letter-spacing: 0.8px;\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (ShopperThemedButton);


/***/ }),

/***/ 20445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shopper; }
});

// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(79225);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(38137);
// EXTERNAL MODULE: ../../../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(60818);
// EXTERNAL MODULE: ../../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(60586);
// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/fetch.js
var fetch = __webpack_require__(75913);
// EXTERNAL MODULE: ../../../../placement-iframe/index.ts + 1 modules
var placement_iframe = __webpack_require__(91280);
// EXTERNAL MODULE: ../../../../../node_modules/next/image.js
var next_image = __webpack_require__(67583);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../../../../node_modules/react/index.js
var react = __webpack_require__(90171);
// EXTERNAL MODULE: ../../../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(24686);
// EXTERNAL MODULE: ./components/common/Branding.tsx + 3 modules
var Branding = __webpack_require__(28420);
// EXTERNAL MODULE: ./components/common/linking.tsx
var linking = __webpack_require__(95922);
// EXTERNAL MODULE: ./components/shopper/ShopperPage.jsx
var ShopperPage = __webpack_require__(97323);
// EXTERNAL MODULE: ./components/shopper/ThemedButton.jsx
var ThemedButton = __webpack_require__(40815);
;// CONCATENATED MODULE: ./components/shopper/images/ShopperImage.jpg
/* harmony default export */ var ShopperImage = ({"src":"/_next/static/media/ShopperImage.a01d3210.jpg","height":930,"width":1125,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAcACAMBIgACEQEDEQH/xAAoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAAAwX/2gAMAwEAAhADEAAAAK0UW//EAB0QAAIABwEAAAAAAAAAAAAAAAEDAAQREhQiQnH/2gAIAQEAAT8AVjrl7QirgOjp7H//xAAYEQACAwAAAAAAAAAAAAAAAAAAARJhkf/aAAgBAgEBPwCKvT//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./components/shopper/svgs/Logo.svg
var Logo = __webpack_require__(66323);
// EXTERNAL MODULE: ./components/use-translation.ts + 7 modules
var use_translation = __webpack_require__(84687);
// EXTERNAL MODULE: ./webserver-page.tsx
var webserver_page = __webpack_require__(15334);
;// CONCATENATED MODULE: ./pages/shopper/index.jsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :root {\n    --text-color-primary: ",
        ";\n    --text-color-secondary: ",
        ";\n  }\n\n  body {\n    background-color: ",
        ";\n  }\n\n  * {\n    font-family: ",
        ";\n    color: var(--text-color-primary);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100vh;\n\n  .form-section {\n    flex-grow: 1;\n\n    height: 100%;\n    max-width: 640px;\n    background: white;\n  }\n\n  .image-section {\n    position: relative;\n    flex-grow: 1;\n  }\n\n  @media (max-width: 700px) {\n    .image-section {\n      display: none;\n    }\n\n    .form-section {\n      max-width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: ",
        ";\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  form {\n    display: flex;\n    flex-direction: column;\n\n    width: 330px;\n    max-width: 400px;\n    margin-bottom: 37px;\n\n    ",
        "\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    font-size: 16px;\n    margin-bottom: 28px;\n  }\n\n  label > input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    line-height: 48px;\n    color: fieldtext;\n  }\n\n  label > input::placeholder {\n    color: var(--text-color-secondary);\n  }\n\n  label:last-of-type {\n    margin-bottom: 15px;\n  }\n\n  form > button {\n    display: inline-block;\n\n    margin-top: 14px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  @media (max-width: 700px) {\n    form {\n      display: flex;\n      flex-direction: column;\n\n      min-width: inherit;\n    }\n\n    form > button {\n      width: 100%;\n      margin-left: 0px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 37px;\n  margin-bottom: 37px;\n\n  @media (max-width: 700px) {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}














function SelfServicePage(param) {
    var embedded = param.embedded, overlayData = param.overlayData;
    (0,react.useEffect)(function() {
        if (embedded) {
            (0,placement_iframe/* connectToPlacementParent */.L6)().then(function() {
            // Connect to the parent to simply resize the iframe
            // no need to store the connection
            });
        }
    }, []);
    if (embedded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopperPage/* default */.Z, {
            pageName: "Embedded self-service",
            embedded: embedded,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCSS, {
                    globalCSS: overlayData.head.globalCSS
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
                    theme: overlayData.theme,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupFormContainer, {
                            embedded: embedded,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupForm, {
                                embedded: embedded
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShopperPage/* default */.Z, {
        pageName: "Self-service",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCSS, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: overlayData.theme,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyle, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupFormContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LookupForm, {})
                        })
                    })
                ]
            })
        ]
    });
}
var GlobalCSS = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
var GlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.header.color;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.color;
}, function(param) {
    var theme = param.theme;
    return theme.modal.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.text.body.fontFamily;
});
var PageLayout = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-section",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: ShopperImage,
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "left",
                    quality: 90,
                    placeholder: "blur",
                    priority: true
                })
            })
        ]
    });
})(_templateObject2());
var LookupFormContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(param) {
    var embedded = param.embedded;
    return embedded ? "fit-content" : "100vh";
});
var LookupForm = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var className = param.className, embedded = param.embedded;
    var ref = (0,react.useState)(""), reference = ref[0], setReference = ref[1];
    var ref1 = (0,react.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,use_translation/* useTranslation */.$)(), t = ref4.t, i18n = ref4.i18n;
    (0,react.useEffect)(function() {
        var explicitLocale = new URLSearchParams(window.location.search).get("locale");
        var browserLocale = window.navigator.language.split("-")[0];
        var locale = explicitLocale || browserLocale;
        if (locale) {
            i18n.changeLanguage(locale);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HideForEmbedded, {
                embedded: embedded,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            maxWidth: "167px",
                            marginBottom: "40px",
                            marginLeft: "3px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormTitle, {
                        children: t("translation:self-service.index.find-your-pre-order")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                        var ref, success, redirect, err, _tmp;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    setLoading(true);
                                    _tmp = {};
                                    return [
                                        4,
                                        (0,fetch/* postJSON */.ty)("/shopper/lookup".concat(window.location.search), (_tmp.email = email, _tmp.reference = reference, _tmp.embedded = embedded, _tmp.locale = i18n.resolvedLanguage, _tmp))
                                    ];
                                case 1:
                                    ref = _state.sent(), success = ref.success, redirect = ref.redirect, err = ref.error;
                                    if (success) {
                                        (0,linking/* routeTo */.E)(redirect);
                                    } else {
                                        setLoading(false);
                                        setError(err);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "lookup-reference",
                        children: [
                            t("translation:self-service.index.reference-number"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "lookup-reference",
                                "data-testid": "lookup-reference",
                                type: "text",
                                name: "reference",
                                placeholder: "#PD123456",
                                value: reference,
                                onChange: function onChange(e) {
                                    return setReference(e.target.value);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: "lookup-email",
                        children: [
                            t("translation:self-service.index.email"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "lookup-email",
                                "data-testid": "lookup-email",
                                type: "text",
                                name: "email",
                                value: email,
                                onChange: function onChange(e) {
                                    return setEmail(e.target.value);
                                }
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        "data-testid": "lookup-error",
                        style: {
                            color: "red"
                        },
                        children: error
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemedButton/* default */.Z, {
                        "data-testid": "lookup-submit",
                        type: "submit",
                        embedded: embedded,
                        disabled: loading,
                        children: t("translation:self-service.index.find-pre-order-cta")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HideForEmbedded, {
                embedded: embedded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Branding/* default */.Z, {})
            })
        ]
    });
})(_templateObject4(), function(param) {
    var embedded = param.embedded;
    return embedded && "\n      position: relative;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    ";
}, function(param) {
    var theme = param.theme;
    return theme.borderColor;
});
var FormTitle = styled_components_browser_esm/* default.h3 */.ZP.h3(_templateObject5());
function HideForEmbedded(param) {
    var children = param.children, embedded = param.embedded;
    return embedded ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
}
/* harmony default export */ var shopper = ((0,webserver_page/* default */.Z)(SelfServicePage));


/***/ }),

/***/ 81669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 5567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 31898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 2647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(83825);
// EXTERNAL MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(81669);
;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}

;// CONCATENATED MODULE: ../../../../../node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 83825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 35823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46859);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 78839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 46859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 31683:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8116,2081,3840,9502,7583,287,1135,4687,6821,9774,2888,179], function() { return __webpack_exec__(89774); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);